var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.ef22915828b9c1c765fbf689a3044738.svg#g';
                    var viewUrl = 'sprites.ef22915828b9c1c765fbf689a3044738.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };